<ng-container>
  <svg
    [ftrIcon]="icon()"
    [iconColor]="iconColor()"
    [iconSize]="iconSize()"
    ftrTooltip
    [showDash]="false"
    [message]="tooltipMessage()"
    [anchorElement]="hostElement"
    [position]="tooltipPosition()"
    [alignment]="tooltipAlignment()"
  ></svg>
  <span class="icon-button__content" #buttonContent>
    <ng-content />
  </span>
</ng-container>
